import { components } from './api'
import appointment from './endpoints/appointment'
import attendance from './endpoints/attendance'
import attendanceForm from './endpoints/attendance-form'
import attendanceShareToken from './endpoints/attendance-share-token'
import auth from './endpoints/auth'
import birdId from './endpoints/bird-id'
import cep from './endpoints/cep'
import cfm from './endpoints/cfm'
import cid from './endpoints/cid'
import city from './endpoints/city'
import concierge from './endpoints/concierge'
import cpfCnpj from './endpoints/cpfCnpj'
import disease from './endpoints/disease'
import exam from './endpoints/exam'
import examProtocol from './endpoints/exam-protocol'
import extension from './endpoints/extension'
import healthPlan from './endpoints/health-plan'
import interestedDisease from './endpoints/interested-disease'
import kba from './endpoints/kba'
import kira from './endpoints/kira'
import legacyAttendance from './endpoints/legacy-attendance'
import lmeAttachment from './endpoints/lme-attachment'
import medicalDocument from './endpoints/medical-document'
import medicalDocumentTemplate from './endpoints/medical-document-template'
import medicine from './endpoints/medicine'
import medicineCategory from './endpoints/medicine-category'
import medicinePresentation from './endpoints/medicine-presentation'
import mixedAttendance from './endpoints/mixed-attendance'
import onboard from './endpoints/onboard'
import organization from './endpoints/organization'
import patient from './endpoints/patient'
import patientNote from './endpoints/patient-note'
import physician from './endpoints/physician'
import physicianAddress from './endpoints/physician-address'
import posology from './endpoints/posology'
import screening from './endpoints/screening'
import screeningCampaign from './endpoints/screening-campaign'
import specialtyType from './endpoints/specialty-type'
import state from './endpoints/state'
import term from './endpoints/term'
import treatment from './endpoints/treatment'
import treatmentActionMechanism from './endpoints/treatment-action-mechanism'
import treatmentComorbidity from './endpoints/treatment-comorbidity'
import uploadedFile from './endpoints/uploaded-file'

export type ApiSchemas = components['schemas']

export const routes = {
  auth,
  appointment,
  attendance,
  attendanceForm,
  attendanceShareToken,
  birdId,
  cfm,
  cid,
  city,
  cep,
  cpfCnpj,
  disease,
  exam,
  examProtocol,
  extension,
  healthPlan,
  interestedDisease,
  kba,
  kira,
  lmeAttachment,
  medicalDocument,
  medicalDocumentTemplate,
  medicine,
  medicineCategory,
  medicinePresentation,
  mixedAttendance,
  legacyAttendance,
  physician,
  physicianAddress,
  patientNote,
  organization,
  patient,
  posology,
  screening,
  screeningCampaign,
  specialtyType,
  state,
  uploadedFile,
  treatment,
  treatmentActionMechanism,
  treatmentComorbidity,
  term,
  onboard,
  concierge,
}

export function useV2Api() {
  return routes
}
